import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
const AboutHero = dynamic(() => import("./AboutHero"));
const Devloper = dynamic(() => import("./Devloper"));
const QualitySection = dynamic(() => import("./QualitySection"));
const CommonCtaSection = dynamic(() =>
  import("../common/CTASection/CommonCtaSection")
);

const Aboutus = ({ aboutdata }) => {
  useEffect(() => {
    console.clear();
  }, []);

  return (
    <main className="main-wrapper about-page-middle">
      <article className="wrapper-inner">
        {/* {loader && <Loader />} */}
        {aboutdata?.map((val, index) => {
          switch (val?.type) {
            case "about_banner":
              return <AboutHero key={index} data={val} />;
            case "about_developer":
              return <Devloper key={index} data={val} />;
            case "about_quality":
              return <QualitySection key={index} data={val} />;
            case "cta":
              return <CommonCtaSection key={index} data={val} />;
          }
        })}
      </article>
    </main>
  );
};

export default Aboutus;
